export const getTranslations = (locale) => {
  const translations = {
    GB: {
      selectOption: "Select an option",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      country: "Country",
      state: "State/Province",
      zip: "ZIP",
      flyPrivate: "Do you currently fly private?",
      currentlyTravel: "How do you currently travel?",
      flyAnnually: "How many hours do you fly annually?",
      program: "Which program are you interested in",
      aboutUs: "How did you hear about us?",
      askQuestion: "Ask us a question",
      keepInformed:
        "Opt in to receive future information from Flexjet. By submitting your email, you agree to our Privacy Policy. You can unsubscribe at any time.",
      optIn:
        "By submitting this form you agree to be contacted by one of our team members via email or phone. You also agree to our Privacy Policy. You can request no further contact from our team at any time.",
      submitButton: "Submit",

      // Options for dropdowns
      flyPrivateOptions: ["Select an option", "Yes", "No"],
      currentlyTravelOptions: [
        "Select an option",
        "Jet Card",
        "Membership",
        "Fractional",
        "Whole Aircraft",
        "Other",
        "Combination",
      ],
      flyAnnuallyOptions: [
        "Select an option",
        "Less than 25 hours",
        "25-50 hours",
        "50-100 hours",
        "More than 100 hours",
      ],
      programOptions: [
        "Select an option",
        "Shared Ownership",
        "Access",
        "Flexjet Helicopter",
        "I Am Unsure",
      ],
      aboutUsOptions: [
        "Select an option",
        "Advertising",
        "Article / Publication",
        "Direct Mail (Postal)",
        "Email",
        "Events",
        "Partnerships",
        "Search / Online",
        "Website",
        "Word of Mouth",
      ],
    },
    FR: {
      selectOption: "Sélectionner une option",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "E-mail",
      phone: "Téléphone",
      country: "Pays",
      state: "État/Province",
      zip: "Code Postal",
      flyPrivate: "Voyagez-vous actuellement en avion privé?",
      currentlyTravel: "Comment voyagez-vous actuellement?",
      flyAnnually: "Combien d'heures volez-vous par an?",
      program: "Quel programme vous intéresse",
      aboutUs: "Comment avez-vous entendu parler de nous?",
      askQuestion: "Posez-nous une question",
      keepInformed:
        "Optez pour recevoir des informations futures de Flexjet. En soumettant votre email, vous acceptez notre politique de confidentialité. Vous pouvez vous désabonner à tout moment.",
      optIn:
        "En soumettant ce formulaire, vous acceptez d'être contacté par un membre de notre équipe par e-mail ou par téléphone. Vous acceptez également notre politique de confidentialité. Vous pouvez demander à ne plus être contacté à tout moment.",
      submitButton: "Envoyer",

      // Options for dropdowns
      flyPrivateOptions: ["Sélectionner une option", "Oui", "Non"],
      currentlyTravelOptions: [
        "Sélectionner une option",
        "Carte Jet",
        "Abonnement",
        "Fractionnaire",
        "Avion complet",
        "Autre",
        "Combinaison",
      ],
      flyAnnuallyOptions: [
        "Sélectionner une option",
        "Moins de 25 heures",
        "25-50 heures",
        "50-100 heures",
        "Plus de 100 heures",
      ],
      programOptions: [
        "Sélectionner une option",
        "Propriété partagée",
        "Accès",
        "Hélicoptère Flexjet",
        "Je ne suis pas sûr",
      ],
      aboutUsOptions: [
        "Sélectionner une option",
        "Publicité",
        "Article / Publication",
        "Courrier direct (Postal)",
        "E-mail",
        "Événements",
        "Partenariats",
        "Recherche / En ligne",
        "Site web",
        "Bouche à oreille",
      ],
    },
    DE: {
      selectOption: "Option auswählen",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      country: "Land",
      state: "Bundesland/Kanton",
      zip: "PLZ",
      flyPrivate: "Reisen Sie derzeit privat?",
      currentlyTravel: "Wie reisen Sie derzeit?",
      flyAnnually: "Wie viele Stunden fliegen Sie jährlich?",
      program: "Welches Programm interessiert Sie",
      aboutUs: "Wie haben Sie von uns erfahren?",
      askQuestion: "Stellen Sie uns eine Frage",
      keepInformed:
        "Optieren Sie für zukünftige Informationen von Flexjet. Indem Sie Ihre E-Mail einreichen, stimmen Sie unserer Datenschutzrichtlinie zu. Sie können sich jederzeit abmelden.",
      optIn:
        "Durch das Absenden dieses Formulars stimmen Sie zu, dass ein Mitglied unseres Teams Sie per E-Mail oder Telefon kontaktiert. Sie stimmen auch unserer Datenschutzrichtlinie zu. Sie können jederzeit weitere Kontakte ablehnen.",
      submitButton: "Absenden",

      // Options for dropdowns
      flyPrivateOptions: ["Option auswählen", "Ja", "Nein"],
      currentlyTravelOptions: [
        "Option auswählen",
        "Jet Card",
        "Mitgliedschaft",
        "Bruchteilseigentum",
        "Ganzes Flugzeug",
        "Andere",
        "Kombination",
      ],
      flyAnnuallyOptions: [
        "Option auswählen",
        "Weniger als 25 Stunden",
        "25-50 Stunden",
        "50-100 Stunden",
        "Mehr als 100 Stunden",
      ],
      programOptions: [
        "Option auswählen",
        "Gemeinsames Eigentum",
        "Zugang",
        "Flexjet-Hubschrauber",
        "Ich bin unsicher",
      ],
      aboutUsOptions: [
        "Option auswählen",
        "Werbung",
        "Artikel / Veröffentlichung",
        "Direktmailing (Postalisch)",
        "E-Mail",
        "Veranstaltungen",
        "Partnerschaften",
        "Suche / Online",
        "Website",
        "Mundpropaganda",
      ],
    },
  };

  return translations[locale] || translations.GB; // Default to GB if locale is unknown
};

export const getErrorMessages = (locale) => {
  const messages = {
    GB: {
      firstName: "First Name is required",
      lastName: "Last Name is required",
      email: "Valid Email is required",
      phone: "Valid Phone is required",
      country: "Country is required",
      state: "State/Province is required",
      zip: "Zip is required",
      flyPrivate: "This Field is required",
      currentlyTravel: "This Field is required",
      flyAnnually: "This Field is required",
      program: "This Field is required",
      aboutUs: "This Field is required",
      optIn: "You must agree to be contacted to submit the form",
    },
    FR: {
      firstName: "Le prénom est requis",
      lastName: "Le nom est requis",
      email: "Un email valide est requis",
      phone: "Un numéro de téléphone valide est requis",
      country: "Le pays est requis",
      state: "État/Province est requis",
      zip: "Le code postal est requis",
      flyPrivate: "Ce champ est requis",
      currentlyTravel: "Ce champ est requis",
      flyAnnually: "Ce champ est requis",
      program: "Ce champ est requis",
      aboutUs: "Ce champ est requis",
      optIn: "Vous devez accepter d'être contacté pour soumettre le formulaire",
    },
    DE: {
      firstName: "Vorname ist erforderlich",
      lastName: "Nachname ist erforderlich",
      email: "Gültige E-Mail ist erforderlich",
      phone: "Gültige Telefonnummer ist erforderlich",
      country: "Land ist erforderlich",
      state: "Bundesland/Provinz ist erforderlich",
      zip: "Postleitzahl ist erforderlich",
      flyPrivate: "Dieses Feld ist erforderlich",
      currentlyTravel: "Dieses Feld ist erforderlich",
      flyAnnually: "Dieses Feld ist erforderlich",
      program: "Dieses Feld ist erforderlich",
      aboutUs: "Dieses Feld ist erforderlich",
      optIn:
        "Sie müssen zustimmen, kontaktiert zu werden, um das Formular einzureichen",
    },
  };

  return messages[locale] || messages.GB;
};

export const getLoadingTranslation = (locale) => {
  const translations = {
    GB: {
      successTitle: "Thank You!",
      successMessage: "Your contact request has been successfully sent.",
      errorTitle: "Please try again.",
      errorMessage: "Something went wrong while submitting your request.",
      spinnerMessage: "Processing...",
    },
    FR: {
      successTitle: "Merci !",
      successMessage: "Votre demande de contact a été envoyée avec succès.",
      errorTitle: "Veuillez réessayer.",
      errorMessage:
        "Une erreur s'est produite lors de l'envoi de votre demande.",
      spinnerMessage: "Traitement en cours...",
    },
    DE: {
      successTitle: "Vielen Dank!",
      successMessage: "Ihre Kontaktanfrage wurde erfolgreich gesendet.",
      errorTitle: "Bitte versuchen Sie es erneut.",
      errorMessage: "Beim Senden Ihrer Anfrage ist ein Fehler aufgetreten.",
      spinnerMessage: "In Bearbeitung...",
    },
  };

  return translations[locale] || translations.GB;
};
